import moment from 'moment';
import dayjs from 'dayjs';
import 'moment/locale/es';
import 'dayjs/locale/es';
import React, { useEffect, useMemo, useState } from 'react';
import { injectIntl, useIntl } from 'react-intl';
import AccionaBigButton from '../../../../components/AccionaBigButton';
import ProviderRecognised from '../../../../components/ProviderRecognised';
import '../../../../services/api/files';
import { getDocumentsByProjectId } from '../../../../services/api/project';
import UploadDocumentModal from './UploadDocumentModal';
import UploadResumeModal from './UploadResumeModal';
import utc from 'dayjs/plugin/utc';
import minMax from 'dayjs/plugin/minMax';
import { useNavigate, useOutletContext } from 'react-router-dom';

dayjs.extend(utc);
dayjs.extend(minMax);
moment.locale(navigator.language.substring(0, 2));
dayjs.locale(navigator.language.substring(0, 2));

const Main = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { project } = useOutletContext();
  const [fileName, setFileName] = useState('');
  const [template, setTemplate] = useState({});
  const [model, setModel] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [uploadModal, setUploadModel] = useState({
    total: 0,
    files: [],
    uploading: false,
    model: '',
  });
  const [preDeliveryNotes, setPreDeliveryNotes] = useState(0);
  const [preprocessedDocs, setPreprocessedDocs] = useState(0);
  const [scannedDocuments, setScannedDocuments] = useState(0);
  const id = project.id_project;

  const hasCemexAsProvider = useMemo(
    () => project?.concrete_providers.some((cp) => cp.provider === 'CEMEX'),
    [project?.concrete_providers],
  );

  useEffect(() => {
    if (uploadModal.uploading === false)
      getDocumentsByProjectId(id).then((response) => {
        setPreDeliveryNotes(response.preDeliveryNotes);
        setPreprocessedDocs(response.preprocessedDocs);
        setScannedDocuments(response.scannedDocuments);
      });
  }, [id, uploadModal.uploading]);

  const onBack = () => {
    setFileName('');
    setTemplate({});
  };

  const onOk = () => {
    setUploadModel({
      total: 0,
      files: [],
      uploading: false,
      model: '',
    });
  };

  if (fileName !== '') {
    return (
      <ProviderRecognised
        fileName={fileName}
        template={template}
        onBack={onBack}
        model={model}
      />
    );
  }

  return (
    <>
      <div className="row">
        {hasCemexAsProvider && (
          <div className="col-xs-12">
            <AccionaBigButton
              icon="cemex-tracking"
              id="cemexTracking"
              msg={intl.formatMessage({ id: `cemexTracking` })}
              display="inline"
              size="slim"
              onClick={() =>
                navigate(
                  `/app/project/${project.id_project}/quality/ocr/cemex-tracking`,
                )
              }
            />
          </div>
        )}
        <div className="col-xs-12 col-sm-6 col-md-6">
          <AccionaBigButton
            icon="read-ocr"
            id="dobleUploadButton"
            msg={intl.formatMessage({ id: `document` })}
            onClick={() => setShowModal(true)}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6">
          <AccionaBigButton
            icon="folder"
            id="templates"
            onClick={() =>
              navigate(
                `/app/project/${project.id_project}/quality/ocr/templates`,
              )
            }
            msg={intl.formatMessage({ id: `button.templates` })}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6">
          <AccionaBigButton
            pendingDocs={preDeliveryNotes}
            icon="smartphone-docs"
            id="preRegisteredDocuments"
            onClick={() =>
              navigate(
                `/app/project/${project.id_project}/quality/ocr/preRegisteredDocuments`,
              )
            }
            msg={intl.formatMessage({ id: `button.preregistered.documents` })}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6">
          <AccionaBigButton
            icon="prm"
            id="prmDocuments"
            onClick={() =>
              navigate(`/app/project/${project.id_project}/quality/ocr/prm`)
            }
            msg={intl.formatMessage({ id: `button.prm` })}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6">
          <AccionaBigButton
            pendingDocs={preprocessedDocs}
            icon="docs-no-ok"
            id="preProcessedDocuments"
            onClick={() =>
              navigate(
                `/app/project/${project.id_project}/quality/ocr/preProcessedDocuments`,
              )
            }
            msg={intl.formatMessage({ id: `button.preprocessed.documents` })}
          />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-6">
          <AccionaBigButton
            pendingDocs={scannedDocuments}
            icon="docs-ok"
            id="scannedDocuments"
            onClick={() =>
              navigate(
                `/app/project/${project.id_project}/quality/ocr/scannedDocuments`,
              )
            }
            msg={intl.formatMessage({ id: `button.scanned.documents` })}
          />
        </div>
      </div>
      <UploadDocumentModal
        pid={id}
        showModal={showModal}
        setShowModal={setShowModal}
        setUploadModel={setUploadModel}
        setTemplate={setTemplate}
        setFileName={setFileName}
        setModel={setModel}
      />
      <UploadResumeModal
        uploadFiles={uploadModal}
        onOk={onOk}
        onCancel={onOk}
      />
    </>
  );
};

export default injectIntl(Main);
